module.exports = __webpack_public_path__ + "static/media/races_icon_banner_dark.112b14fa.svg";